var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as R from "../libs/ramda";
var Record = /** @class */ (function () {
    function Record(row) {
        var _this = this;
        this.id = -1;
        this.key = "";
        this.link = "";
        this.type = "post";
        this.author = {};
        this.subject = "";
        this.description = "";
        this.thumbnail = "";
        this.media = [];
        this.properties = {};
        this.metadata = [];
        this.relations = [];
        this.createdAt = new Date();
        this.updatedAt = new Date();
        this.key = Math.random().toString(36).substring(2, 11);
        Object.entries(row).forEach(function (column) {
            var key = column[0], value = column[1];
            _this[key] = value;
        });
        if (!row.createdAt)
            this.createdAt = new Date();
        if (!row.updatedAt)
            this.updatedAt = new Date();
    }
    Record.prototype.update = function (row) {
        var _this = this;
        Object.entries(row).forEach(function (column) {
            var key = column[0], value = column[1];
            _this[key] = value;
        });
        if (!row.updatedAt)
            this.updatedAt = new Date();
        return this;
    };
    Record.prototype.prop = function (key, value) {
        if (key && !R.isNil(value)) {
            this.properties[key].value = value;
            return this.properties[key].value;
        }
        if (key) {
            return R.has(key)(this.properties)
                ? this.properties[key].value
                : undefined;
        }
        return Object.entries(this.properties).reduce(function (a, b) {
            var _a;
            return (__assign(__assign({}, a), (_a = {}, _a[b[0]] = b[1].value, _a)));
        }, {});
    };
    Record.prototype.meta = function (key, value) {
        var res = {};
        if (key) {
            res = R.find(function (v) { return v.name === key; })(this.metadata);
        }
        if (key && !R.isNil(value)) {
            res.value = value;
            return R.prop("value", res);
        }
        if (key) {
            var res_1 = R.find(function (v) { return v.name === key; })(this.metadata);
            return R.prop("value", res_1);
        }
        return this.metadata.map(function (_a) {
            var name = _a.name, value = _a.value;
            return ({ name: name, value: value });
        });
    };
    Record.prototype.enum = function (entries) {
        if (typeof entries === "object") {
            if (Array.isArray(entries)) {
                return entries.reduce(function (a, b) {
                    var _a;
                    return (__assign(__assign({}, a), (_a = {}, _a[b.name] = b.value, _a)));
                }, {});
            }
            else {
                return Object.entries(entries).reduce(function (a, b) {
                    var _a;
                    var key = b[0], data = b[1];
                    return __assign(__assign({}, a), (_a = {}, _a[key] = data.value, _a));
                }, {});
            }
        }
        return [];
    };
    return Record;
}());
export default Record;
